import type {ActivityVersion, StudentAttempt} from "./activity-library";

const badges = {
  live: {id: "live", label: "En réalisation"},
  pending: {id: "pending", label: "À corriger"},
  progress: {id: "progress", label: "Correction en cours"},
  done: {id: "done", label: "Corrigé"},
};
export function correctionState(status: string) {
  if (status === "not_started" || status === "in_progress") return badges.live;
  return status === "completed" ? badges.done : status === "reviewed" ? badges.progress : badges.pending;
}
export function aggregateCorrectionState(statuses: string[]) {
  if (statuses.length && statuses.every(s => s === "completed")) return badges.done;
  if (statuses.some(s => s === "not_started" || s === "in_progress")) return badges.live;
  return statuses.some(s => s === "reviewed" || s === "completed") ? badges.progress : badges.pending;
}
export function liveCorrectionGrades(attempt: StudentAttempt, version: Pick<ActivityVersion, "checkpoints">) {
  return version.checkpoints.flatMap(checkpoint => {
    const result = attempt.competenceResults[checkpoint.id];
    return result ? [{checkpointId: checkpoint.id, code: checkpoint.competenceCode, level: result.level}] : [];
  });
}
